import React, { useReducer, useState } from "react";
import {
  Box,
  Button,
  ButtonProps,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  InputLabel,
  Link,
  styled,
  SvgIcon,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import variables from "../../../assets/styles/variables.module.scss";
import AuthCommon from "../../Components/Auth";
import { LOGIN } from "../../../Services/Endpoint";
import {
  ShowError,
  ShowSuccess,
} from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import axios from "axios";
import { useDispatch } from "react-redux";
import {
  SetSession,
  ValidateIsEmail,
} from "../../../Shared-ui/utils/Auth/AuthHelpers";
import { useNavigate } from "react-router-dom";
import { SetLogin } from "../../../Shared-ui/Store/AuthReducer/AuthActions";
import useAuth from "../../../Shared-ui/Hooks/useAuth";
import AccountReducer, {
  initialStateAuth,
} from "../../../Shared-ui/Store/AuthReducer/AuthReducer";
import { TokenKeyType } from "../../../Constant/Setting";

const MicrosoftSvgIcon = (props: any) => (
  <SvgIcon {...props}>
    <rect x="0" y="0" width="11.5" height="11.5" fill="#F25022" />
    <rect x="12.5" y="0" width="11.5" height="11.5" fill="#7FBA00" />
    <rect x="0" y="12.5" width="11.5" height="11.5" fill="#00A4EF" />
    <rect x="12.5" y="12.5" width="11.5" height="11.5" fill="#FFB900" />
  </SvgIcon>
);

interface MyComponentProps { }

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: variables.whiteColor,
  backgroundColor: variables.primaryColor,
  "&:hover": {
    backgroundColor: variables.secondaryColor,
  },
}));

const Login: React.FC<MyComponentProps> = ({ }) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { isLogin } = useAuth();

  const [showPassword, setShowPassword] = useState<boolean>(false); // State for toggling password visibility
  const [loginForm, setLoginForm] = useState({ username: "", password: "" });
  const [loginErr, setloginErr] = useState({
    username: { error: "", value: false },
    password: { error: "", value: false },
  });
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setLoginForm((preVal) => ({ ...preVal, [name]: value.trim() }));
  };

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev); // Toggle show/hide password
  };
  const validateLoginForm = () => {
    if (!ValidateIsEmail(loginForm.username)) {
      setloginErr((preVal: any) => ({
        ...preVal,
        username: { error: "Please enter valid email", value: true },
      }));
      return false;
    } else {
      setloginErr((preVal: any) => ({
        ...preVal,
        username: { error: "", value: false },
      }));
    }

    if (!loginForm.password.trim()) {
      setloginErr((preVal: any) => ({
        ...preVal,
        password: { error: "Please enter valid password", value: true },
      }));
      return false;
    } else {
      setloginErr((preVal: any) => ({
        ...preVal,
        password: { error: "", value: false },
      }));
    }
    return true;
  };
  const handleSubmit = async () => {
    // const token = "asdsadasdasdasdasdasdasdasdasdadasdsadasdasdasdsad"
    // SetSession(token)
    // dispatch(SetLogin({ TokenKeyName: token }))
    if (!validateLoginForm()) return;
    try {
      dispatch(StartLoading())
      const reponse: any = await axios.post(LOGIN, loginForm, { headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }}).then((res: any) => { return res.data })
      const token = reponse?.access_token
      const tokenType = reponse.token_type
      if (token) {
        SetSession(token)
        dispatch(SetLogin({ TokenKeyName: token, TokenKeyType:tokenType}))
        navigate('/home')
      }
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail))
      console.log(err)
    } finally {
      dispatch(StopLoading())
    }

  }

  const handleKeyDown = async (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault()
      await handleSubmit()
    }
  }
  return (
    <>
      <Box
        sx={{
          display: "flex",
          minHeight: "calc(100vh - 78px)",
          flexDirection: { md: "row", sm: "column", xs: "column" },
        }}
      >
        <AuthCommon />

        <Box
          sx={{
            display: "flex",
            width: "100%",
            px: { xl: 30, lg: 20, md: 8, sm: 8, xs: 5 },
            py: { sm: 6, xs: 3 },
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            <Typography variant="h4" fontWeight="500" gutterBottom>
              Sign In
            </Typography>
            <FormControl
              fullWidth
              variant="outlined"
              error={loginErr.username.value}
            >
              <InputLabel
                htmlFor="email"
                shrink
                sx={{ background: "#fff", px: 0.5 }}
              >
                Business Email
              </InputLabel>
              <TextField
                id="username"
                name="username"
                placeholder="Enter your business email"
                value={loginForm.username}
                sx={{ background: "white" }}
                onChange={handleChange}
                inputProps={{ maxLength: 50 }}
                error={loginErr.username.value}
                helperText={loginErr.username.error}
                onKeyDown={(e)=>handleKeyDown(e)}
              />
            </FormControl>
            <FormControl
              fullWidth
              variant="outlined"
              error={loginErr.password.value}
            >
              <InputLabel
                htmlFor="password"
                shrink
                sx={{ background: "#fff", px: 0.5 }}
              >
                Password
              </InputLabel>
              <TextField
                id="password"
                name="password"
                type={showPassword ? "text" : "password"} // Toggle password visibility
                value={loginForm.password}
                onChange={handleChange}
                placeholder="Enter your password"
                error={loginErr.password.value}
                helperText={loginErr.password.error}
                sx={{ background: "white" }}
                onKeyDown={(e) => handleKeyDown(e)}
                inputProps={{ maxLength: 32 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleTogglePassword}
                        edge="end"
                        aria-label="toggle password visibility"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>

            {/* <FormControl component="fieldset">
              <FormGroup aria-label="position" row>
                <FormControlLabel
                  value="end"
                  control={<Checkbox />}
                  label="I accept the Terms and Conditions"
                  labelPlacement="end"
                />
              </FormGroup>
            </FormControl> */}

            <Box>
              <Typography
                onClick={() => navigate("/forgot")}
                sx={{
                  color: variables.textColor,
                  fontSize: "14px",
                  textAlign: "right",
                  "&:hover": {
                    textDecoration: "underline", // Add underline on hover
                    cursor: "pointer",
                  },
                }}
              >
                Forgot password?
              </Typography>
            </Box>

            <ColorButton
              variant="contained"
              disableElevation
              size="large"
              sx={{
                textTransform: "capitalize",
                fontWeight: "400",
                whiteSpace: "nowrap",
              }}
              onClick={() => handleSubmit()}
              // disabled={!loginForm.username || !loginForm.password}
              onKeyDown={(e)=>handleKeyDown(e)}
            >
              Sign in
            </ColorButton>

            {/* <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              width="100%"
              sx={{ my: 2 }}
            >
              <Box flex={1} height="1px" bgcolor="lightgray" />

              <Typography variant="body2" sx={{ mx: 2, color: "gray" }}>
                Or, Login with
              </Typography>

              <Box flex={1} height="1px" bgcolor="lightgray" />
            </Box> */}

            {/* <Button
              variant="outlined"
              size="large"
              startIcon={<MicrosoftSvgIcon />}
              sx={{
                textTransform: "capitalize",
                fontWeight: "400",
                whiteSpace: "nowrap",
                color: variables.textColor,
                borderColor: variables.textColor,
                "&:hover": {
                  color: variables.secondaryColor,
                  borderColor: variables.secondaryColor,
                },
              }}
            >
              Sign up with Microsoft
            </Button> */}

            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap="10px"
            >
              <Typography variant="body2">Don't have an account ?</Typography>
              <Typography
                onClick={() => navigate("/register")}
                sx={{
                  color: variables.primaryColor,
                  fontSize: "14px",
                  "&:hover": {
                    textDecoration: "underline", // Add underline on hover
                    cursor: "pointer",
                  },
                }}
              >
                Register here
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Login;
